import axios from "@/utils/api-v1.js"

export default {
  SET_BEARER(state, accessToken) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
  },
}
